var _g, _g2, _path, _g3, _rect, _path2, _rect2, _g4, _g5, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g6, _path15, _g7, _path16, _g8, _path17, _g9, _path18, _path19, _path20, _path21, _g10, _path22, _path23, _path24, _g11, _g12, _path25, _path26, _path27, _g13, _g14, _path28, _g15, _path29, _path30, _path31, _path32, _path33, _g16, _path34, _rect3, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 804.575,
    height: 541.015,
    viewBox: "0 0 804.575 541.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_68354",
    "data-name": "Group 68354",
    transform: "translate(0 15.295)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(0 15.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68272",
    "data-name": "Group 68272",
    transform: "translate(0 438.017)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17324",
    "data-name": "Rectangle 17324",
    width: 804.575,
    height: 0.402,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17325",
    "data-name": "Rectangle 17325",
    width: 53.298,
    height: 0.402,
    transform: "translate(670.66 25.901)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17326",
    "data-name": "Rectangle 17326",
    width: 13.989,
    height: 0.402,
    transform: "translate(518.994 30.267)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17327",
    "data-name": "Rectangle 17327",
    width: 30.883,
    height: 0.402,
    transform: "translate(638.166 10.958)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17328",
    "data-name": "Rectangle 17328",
    width: 69.505,
    height: 0.402,
    transform: "translate(84.414 13.662)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17329",
    "data-name": "Rectangle 17329",
    width: 10.191,
    height: 0.402,
    transform: "translate(168.246 13.662)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17330",
    "data-name": "Rectangle 17330",
    width: 150.738,
    height: 0.402,
    transform: "translate(211.557 20.456)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68280",
    "data-name": "Group 68280",
    transform: "translate(125.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68273",
    "data-name": "Group 68273",
    transform: "translate(383.619 277.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13427",
    "data-name": "Path 13427",
    d: "M316.544,282.454H509.869A13.261,13.261,0,0,1,497.192,295.7c-20.776.937-52.737,4.224-62.871,15.72-18.895,21.429-17.063,96.7,5.566,114.135,7.1,5.466,27.782,16.32,27.782,16.32H358.746s19.329-11.072,26.046-16.32c22.5-17.577,23.157-92.8,4.176-114.135-9.74-10.944-39.7-14.479-59.8-15.594A13.38,13.38,0,0,1,316.544,282.454Z",
    transform: "translate(-316.544 -282.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13428",
    "data-name": "Path 13428",
    d: "M477.984,291.121c-19.636,1.574-43.169,5.455-51.6,15.018a38.029,38.029,0,0,0-6.392,11.071H387.521a38.67,38.67,0,0,0-6.491-11.071c-8.464-9.51-32.193-13.424-51.456-15.018Z",
    transform: "translate(-308.607 -277.174)",
    fill: "#f4f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68274",
    "data-name": "Group 68274",
    transform: "translate(427.862 247.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13429",
    "data-name": "Path 13429",
    d: "M382.147,293.888l2.629-30.049H346.668l-2.629,30.049Z",
    transform: "translate(-344.039 -263.839)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13430",
    "data-name": "Path 13430",
    d: "M367.721,293.888l2.629-30.049H372.4l-2.629,30.049Z",
    transform: "translate(-329.613 -263.839)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13431",
    "data-name": "Path 13431",
    d: "M376.957,289.664l2.093-23.922H348.713l-2.093,23.922Z",
    transform: "translate(-342.467 -262.679)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13432",
    "data-name": "Path 13432",
    d: "M373.621,286.95l1.748-19.983H350.027l-1.748,19.983Z",
    transform: "translate(-341.456 -261.933)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68276",
    "data-name": "Group 68276",
    transform: "translate(472.256 228.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68275",
    "data-name": "Group 68275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13433",
    "data-name": "Path 13433",
    d: "M377.011,300.832h38.281l-4.247-48.548H372.763Z",
    transform: "translate(-370.936 -252.285)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13434",
    "data-name": "Path 13434",
    d: "M377.7,300.832h-1.828l-4.247-48.548h1.828Z",
    transform: "translate(-371.627 -252.285)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13435",
    "data-name": "Path 13435",
    d: "M378.839,294.009h30.475l-3.381-38.648H375.458Z",
    transform: "translate(-369.294 -250.411)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13436",
    "data-name": "Path 13436",
    d: "M380.014,289.623h25.458l-2.825-32.285H377.19Z",
    transform: "translate(-368.239 -249.206)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13437",
    "data-name": "Path 13437",
    d: "M389.8,269.225h0a4.428,4.428,0,0,1-6.263,0h0a4.428,4.428,0,0,1,0-6.263h0a4.431,4.431,0,0,1,6.263,0h0A4.428,4.428,0,0,1,389.8,269.225Z",
    transform: "translate(-365.164 -246.569)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13438",
    "data-name": "Path 13438",
    d: "M386.133,270.1h0a3.243,3.243,0,0,1,4.586,0h0a3.242,3.242,0,0,1-2.293,5.535h0A3.243,3.243,0,0,1,386.133,270.1Z",
    transform: "translate(-363.374 -242.013)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68277",
    "data-name": "Group 68277",
    transform: "translate(0 22.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17331",
    "data-name": "Rectangle 17331",
    width: 180.528,
    height: 199.659,
    transform: "translate(186.292 199.659) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17332",
    "data-name": "Rectangle 17332",
    width: 187.239,
    height: 199.659,
    transform: "translate(187.239 199.659) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17333",
    "data-name": "Rectangle 17333",
    width: 171.697,
    height: 184.118,
    transform: "translate(179.618 190.486) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17334",
    "data-name": "Rectangle 17334",
    width: 4.965,
    height: 184.118,
    transform: "translate(12.886 190.486) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17335",
    "data-name": "Rectangle 17335",
    width: 4.965,
    height: 167.703,
    transform: "translate(12.355 143.733) rotate(-90)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17336",
    "data-name": "Rectangle 17336",
    width: 174.36,
    height: 8.335,
    transform: "translate(182.281 138.768) rotate(180)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68278",
    "data-name": "Group 68278",
    transform: "translate(337.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13439",
    "data-name": "Path 13439",
    d: "M383.106,166.556s1.611-10.617-6.134-17.425-7.064-10.859-4.852-11.386,4.256,6.279,7.66,8.152c0,0,.108-9.7-3.35-13.277s-5.272-12.781-1.982-12.944,3.632,5.47,4.313,9.462,4.346,9.61,4.346,9.61.716-8.68,2.951-12.255-3.724-11.744-1.426-15.317,6.384,3.233,6.042,10.892-5.447,15.829-4.255,23.83c0,0,2.253-5.618,4.275-6.128s4.065-4.226,5.426-5.6,3.064,3.389,0,7.814-10.894,16.265-9.7,25.833Z",
    transform: "translate(-237.57 -110.195)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13440",
    "data-name": "Path 13440",
    d: "M376.509,142.218l-2.536,15.915a8.092,8.092,0,0,0,7.991,9.365h2.7a8.092,8.092,0,0,0,7.991-9.365l-2.536-15.915Z",
    transform: "translate(-235.602 -90.688)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17337",
    "data-name": "Rectangle 17337",
    width: 179.265,
    height: 9.21,
    transform: "translate(0 70.938)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17338",
    "data-name": "Rectangle 17338",
    width: 7.897,
    height: 33.951,
    transform: "translate(8.251 36.986)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17339",
    "data-name": "Rectangle 17339",
    width: 7.898,
    height: 33.951,
    transform: "translate(46.439 36.986)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17340",
    "data-name": "Rectangle 17340",
    width: 7.898,
    height: 33.951,
    transform: "translate(89.906 37.48) rotate(-9.779)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17341",
    "data-name": "Rectangle 17341",
    width: 7.898,
    height: 29.477,
    transform: "translate(18.037 41.46)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17342",
    "data-name": "Rectangle 17342",
    width: 7.898,
    height: 29.477,
    transform: "translate(36.19 41.46)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17343",
    "data-name": "Rectangle 17343",
    width: 7.898,
    height: 29.477,
    transform: "translate(82.009 41.46)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17344",
    "data-name": "Rectangle 17344",
    width: 7.898,
    height: 29.477,
    transform: "translate(57.001 42.162) rotate(-12.527)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17345",
    "data-name": "Rectangle 17345",
    width: 3.949,
    height: 35.637,
    transform: "translate(28.815 35.301)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17346",
    "data-name": "Rectangle 17346",
    width: 3.949,
    height: 35.637,
    transform: "translate(75.79 35.301)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68279",
    "data-name": "Group 68279",
    transform: "translate(337.597 104.06)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17347",
    "data-name": "Rectangle 17347",
    width: 179.265,
    height: 9.21,
    transform: "translate(179.265 44.847) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17348",
    "data-name": "Rectangle 17348",
    width: 7.898,
    height: 33.951,
    transform: "translate(171.014 35.637) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17349",
    "data-name": "Rectangle 17349",
    width: 7.898,
    height: 33.951,
    transform: "translate(132.826 35.637) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17350",
    "data-name": "Rectangle 17350",
    width: 7.898,
    height: 33.951,
    transform: "translate(83.592 35.637) rotate(-170.222)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17351",
    "data-name": "Rectangle 17351",
    width: 7.897,
    height: 29.477,
    transform: "translate(161.228 35.637) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17352",
    "data-name": "Rectangle 17352",
    width: 7.898,
    height: 29.477,
    transform: "translate(143.075 35.637) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17353",
    "data-name": "Rectangle 17353",
    width: 7.898,
    height: 29.477,
    transform: "translate(97.256 35.637) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17354",
    "data-name": "Rectangle 17354",
    width: 7.898,
    height: 29.477,
    transform: "translate(115.871 35.637) rotate(-167.474)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17355",
    "data-name": "Rectangle 17355",
    width: 3.949,
    height: 35.637,
    transform: "translate(150.45 35.637) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17356",
    "data-name": "Rectangle 17356",
    width: 3.949,
    height: 35.637,
    transform: "translate(103.475 35.637) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17357",
    "data-name": "Rectangle 17357",
    width: 38.481,
    height: 26.567,
    transform: "translate(55.682 35.332) rotate(180)",
    fill: "#f5f5f5"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(90.291 489.278)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    cx: 311.997,
    cy: 18.221,
    rx: 311.997,
    ry: 18.221,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(494.927 345.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68283",
    "data-name": "Group 68283",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13444",
    "data-name": "Path 13444",
    d: "M346.016,437.366s-7.969-17.388,1.138-34.531,11.745-21.18,5.939-24.692-8.467,13.713-8.467,13.713-4.893-11.85-.853-24.251,6.573-32.6,1.056-34.767-1.052,25.2-5.84,34.526c0,0-4.021-10.384-4.683-20.344s.372-25.867-3.986-29.946-7.148-1.257-2.866,20.724a229.934,229.934,0,0,1,4.25,39.851s-9.457-28.834-15.805-29.676-6.338,8.5-.906,16.6,15.911,22.61,17.63,30.077c0,0-10.381-21.7-19.719-15.05s8.128,19.759,15.911,24.495,13.19,34.424,13.19,34.424Z",
    transform: "translate(-310.226 -315.497)",
    fill: "#8b9905",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13445",
    "data-name": "Path 13445",
    d: "M324.86,461.64s15.551-37.249,6.24-54.253-12-21-6.235-24.6,8.631,13.585,8.631,13.585,4.75-11.921.562-24.261-6.964-32.5-1.474-34.748,1.356,25.18,6.255,34.436c0,0,3.9-10.443,4.438-20.414s-.681-25.859,3.627-30,7.132-1.365,3.114,20.679a230.124,230.124,0,0,0-3.772,39.912s9.111-28.974,15.448-29.909,6.44,8.4,1.1,16.581-15.638,22.845-17.266,30.337c0,0,10.12-21.854,19.537-15.343s-7.89,19.878-15.617,24.729-20.568,54.359-20.568,54.359Z",
    transform: "translate(-298.878 -312.898)",
    fill: "#d1e600"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68282",
    "data-name": "Group 68282",
    transform: "translate(5.457 116.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13446",
    "data-name": "Path 13446",
    d: "M375.071,387.908H310.962l5.189,45.877h53.732Z",
    transform: "translate(-310.962 -387.908)",
    fill: "#333"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Window",
    transform: "translate(334.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68311",
    "data-name": "Group 68311"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17358",
    "data-name": "Rectangle 17358",
    width: 346.799,
    height: 308.93,
    rx: 2.478,
    transform: "translate(13.119 5.705)",
    fill: "#e7e7e7",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17359",
    "data-name": "Rectangle 17359",
    width: 346.799,
    height: 308.929,
    rx: 2.478,
    transform: "translate(0)",
    fill: "#2d5794"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13447",
    "data-name": "Path 13447",
    d: "M207.859,117.945V395.387c0,2.2,1.48,3.988,3.307,3.988H551.351c1.826,0,3.307-1.786,3.307-3.988V117.945Z",
    transform: "translate(-207.859 -90.444)",
    fill: "#2d5794",
    opacity: 0.45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17360",
    "data-name": "Rectangle 17360",
    width: 338.576,
    height: 245.021,
    transform: "translate(4.112 43.858)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68284",
    "data-name": "Group 68284",
    transform: "translate(293.942 8.902)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    cx: 5.081,
    cy: 5.085,
    rx: 5.081,
    ry: 5.085,
    transform: "translate(33.316)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_398",
    "data-name": "Ellipse 398",
    cx: 5.081,
    cy: 5.085,
    rx: 5.081,
    ry: 5.085,
    transform: "translate(16.658)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13448",
    "data-name": "Path 13448",
    d: "M402.639,110.173a5.082,5.082,0,1,1-5.082-5.085A5.083,5.083,0,0,1,402.639,110.173Z",
    transform: "translate(-392.476 -105.088)",
    fill: "#fff",
    opacity: 0.6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68310",
    "data-name": "Group 68310",
    transform: "translate(24.001 72.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68287",
    "data-name": "Group 68287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68285",
    "data-name": "Group 68285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13449",
    "data-name": "Path 13449",
    d: "M275.02,145.885v63.2l-16.256,19.6h-35.99V145.885Z",
    transform: "translate(-222.774 -145.885)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13450",
    "data-name": "Path 13450",
    d: "M275.02,145.885v63.2l-16.256,19.6h-35.99V145.885Z",
    transform: "translate(-222.774 -145.885)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13451",
    "data-name": "Path 13451",
    d: "M261.4,185.162l-16.256,19.6v-19.6Z",
    transform: "translate(-209.15 -121.96)",
    fill: "#407bff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68286",
    "data-name": "Group 68286",
    transform: "translate(8.098 11.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17361",
    "data-name": "Rectangle 17361",
    width: 36.05,
    height: 2.373,
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17362",
    "data-name": "Rectangle 17362",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 8.994)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17363",
    "data-name": "Rectangle 17363",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 17.988)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17364",
    "data-name": "Rectangle 17364",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 26.982)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17365",
    "data-name": "Rectangle 17365",
    width: 26.727,
    height: 2.373,
    transform: "translate(0 35.976)",
    fill: "#407bff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68290",
    "data-name": "Group 68290",
    transform: "translate(82.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68288",
    "data-name": "Group 68288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13452",
    "data-name": "Path 13452",
    d: "M326.518,145.885v63.2l-16.256,19.6h-35.99V145.885Z",
    transform: "translate(-274.272 -145.885)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13453",
    "data-name": "Path 13453",
    d: "M326.518,145.885v63.2l-16.256,19.6h-35.99V145.885Z",
    transform: "translate(-274.272 -145.885)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13454",
    "data-name": "Path 13454",
    d: "M312.894,185.162l-16.256,19.6v-19.6Z",
    transform: "translate(-260.648 -121.96)",
    fill: "#407bff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68289",
    "data-name": "Group 68289",
    transform: "translate(8.098 11.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17366",
    "data-name": "Rectangle 17366",
    width: 36.05,
    height: 2.373,
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17367",
    "data-name": "Rectangle 17367",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 8.994)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17368",
    "data-name": "Rectangle 17368",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 17.988)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17369",
    "data-name": "Rectangle 17369",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 26.982)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17370",
    "data-name": "Rectangle 17370",
    width: 26.727,
    height: 2.373,
    transform: "translate(0 35.976)",
    fill: "#407bff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68293",
    "data-name": "Group 68293",
    transform: "translate(165.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68291",
    "data-name": "Group 68291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13455",
    "data-name": "Path 13455",
    d: "M378.016,145.885v63.2l-16.256,19.6H325.77V145.885Z",
    transform: "translate(-325.77 -145.885)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13456",
    "data-name": "Path 13456",
    d: "M378.016,145.885v63.2l-16.256,19.6H325.77V145.885Z",
    transform: "translate(-325.77 -145.885)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13457",
    "data-name": "Path 13457",
    d: "M364.392,185.162l-16.256,19.6v-19.6Z",
    transform: "translate(-312.146 -121.96)",
    fill: "#407bff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68292",
    "data-name": "Group 68292",
    transform: "translate(8.098 11.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17371",
    "data-name": "Rectangle 17371",
    width: 36.05,
    height: 2.373,
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17372",
    "data-name": "Rectangle 17372",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 8.994)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17373",
    "data-name": "Rectangle 17373",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 17.988)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17374",
    "data-name": "Rectangle 17374",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 26.982)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17375",
    "data-name": "Rectangle 17375",
    width: 26.727,
    height: 2.373,
    transform: "translate(0 35.976)",
    fill: "#407bff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68296",
    "data-name": "Group 68296",
    transform: "translate(248.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68294",
    "data-name": "Group 68294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13458",
    "data-name": "Path 13458",
    d: "M429.514,145.885v63.2l-16.256,19.6h-35.99V145.885Z",
    transform: "translate(-377.268 -145.885)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13459",
    "data-name": "Path 13459",
    d: "M429.514,145.885v63.2l-16.256,19.6h-35.99V145.885Z",
    transform: "translate(-377.268 -145.885)",
    fill: "#fcfdff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13460",
    "data-name": "Path 13460",
    d: "M415.89,185.162l-16.256,19.6v-19.6Z",
    transform: "translate(-363.644 -121.96)",
    fill: "#407bff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68295",
    "data-name": "Group 68295",
    transform: "translate(8.098 11.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17376",
    "data-name": "Rectangle 17376",
    width: 36.05,
    height: 2.373,
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17377",
    "data-name": "Rectangle 17377",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 8.994)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17378",
    "data-name": "Rectangle 17378",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 17.988)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17379",
    "data-name": "Rectangle 17379",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 26.982)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17380",
    "data-name": "Rectangle 17380",
    width: 26.727,
    height: 2.373,
    transform: "translate(0 35.976)",
    fill: "#407bff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68309",
    "data-name": "Group 68309",
    transform: "translate(0 109.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68299",
    "data-name": "Group 68299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68297",
    "data-name": "Group 68297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13461",
    "data-name": "Path 13461",
    d: "M275.02,213.885v63.2l-16.256,19.6h-35.99V213.885Z",
    transform: "translate(-222.774 -213.885)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13462",
    "data-name": "Path 13462",
    d: "M275.02,213.885v63.2l-16.256,19.6h-35.99V213.885Z",
    transform: "translate(-222.774 -213.885)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13463",
    "data-name": "Path 13463",
    d: "M261.4,253.162l-16.256,19.6v-19.6Z",
    transform: "translate(-209.15 -189.96)",
    fill: "#407bff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68298",
    "data-name": "Group 68298",
    transform: "translate(8.098 11.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17381",
    "data-name": "Rectangle 17381",
    width: 36.05,
    height: 2.373,
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17382",
    "data-name": "Rectangle 17382",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 8.994)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17383",
    "data-name": "Rectangle 17383",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 17.988)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17384",
    "data-name": "Rectangle 17384",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 26.982)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17385",
    "data-name": "Rectangle 17385",
    width: 26.727,
    height: 2.373,
    transform: "translate(0 35.976)",
    fill: "#407bff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68302",
    "data-name": "Group 68302",
    transform: "translate(82.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68300",
    "data-name": "Group 68300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13464",
    "data-name": "Path 13464",
    d: "M326.518,213.885v63.2l-16.256,19.6h-35.99V213.885Z",
    transform: "translate(-274.272 -213.885)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13465",
    "data-name": "Path 13465",
    d: "M326.518,213.885v63.2l-16.256,19.6h-35.99V213.885Z",
    transform: "translate(-274.272 -213.885)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13466",
    "data-name": "Path 13466",
    d: "M312.894,253.162l-16.256,19.6v-19.6Z",
    transform: "translate(-260.648 -189.96)",
    fill: "#407bff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68301",
    "data-name": "Group 68301",
    transform: "translate(8.098 11.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17386",
    "data-name": "Rectangle 17386",
    width: 36.05,
    height: 2.373,
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17387",
    "data-name": "Rectangle 17387",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 8.994)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17388",
    "data-name": "Rectangle 17388",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 17.988)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17389",
    "data-name": "Rectangle 17389",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 26.982)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17390",
    "data-name": "Rectangle 17390",
    width: 26.727,
    height: 2.373,
    transform: "translate(0 35.976)",
    fill: "#407bff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68305",
    "data-name": "Group 68305",
    transform: "translate(165.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68303",
    "data-name": "Group 68303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13467",
    "data-name": "Path 13467",
    d: "M378.016,213.885v63.2l-16.256,19.6H325.77V213.885Z",
    transform: "translate(-325.77 -213.885)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13468",
    "data-name": "Path 13468",
    d: "M378.016,213.885v63.2l-16.256,19.6H325.77V213.885Z",
    transform: "translate(-325.77 -213.885)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13469",
    "data-name": "Path 13469",
    d: "M364.392,253.162l-16.256,19.6v-19.6Z",
    transform: "translate(-312.146 -189.96)",
    fill: "#407bff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68304",
    "data-name": "Group 68304",
    transform: "translate(8.098 11.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17391",
    "data-name": "Rectangle 17391",
    width: 36.05,
    height: 2.373,
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17392",
    "data-name": "Rectangle 17392",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 8.994)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17393",
    "data-name": "Rectangle 17393",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 17.988)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17394",
    "data-name": "Rectangle 17394",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 26.982)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17395",
    "data-name": "Rectangle 17395",
    width: 26.727,
    height: 2.373,
    transform: "translate(0 35.976)",
    fill: "#407bff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68308",
    "data-name": "Group 68308",
    transform: "translate(248.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68306",
    "data-name": "Group 68306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13470",
    "data-name": "Path 13470",
    d: "M429.514,213.885v63.2l-16.256,19.6h-35.99V213.885Z",
    transform: "translate(-377.268 -213.885)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13471",
    "data-name": "Path 13471",
    d: "M429.514,213.885v63.2l-16.256,19.6h-35.99V213.885Z",
    transform: "translate(-377.268 -213.885)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13472",
    "data-name": "Path 13472",
    d: "M415.89,253.162l-16.256,19.6v-19.6Z",
    transform: "translate(-363.644 -189.96)",
    fill: "#407bff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68307",
    "data-name": "Group 68307",
    transform: "translate(8.098 11.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17396",
    "data-name": "Rectangle 17396",
    width: 36.05,
    height: 2.373,
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17397",
    "data-name": "Rectangle 17397",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 8.994)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17398",
    "data-name": "Rectangle 17398",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 17.988)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17399",
    "data-name": "Rectangle 17399",
    width: 36.05,
    height: 2.373,
    transform: "translate(0 26.982)",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17400",
    "data-name": "Rectangle 17400",
    width: 26.727,
    height: 2.373,
    transform: "translate(0 35.976)",
    fill: "#407bff",
    opacity: 0.3
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Desk",
    transform: "translate(202.043 212.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68318",
    "data-name": "Group 68318",
    transform: "translate(86.443 0)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13478",
    "data-name": "Path 13478",
    d: "M231.223,297.62H192.216v-1.5h8.81a2.524,2.524,0,0,0,2.475-2.09l3.939-23.463.772-4.618h13.362l11.951,28.2A2.5,2.5,0,0,1,231.223,297.62Z",
    transform: "translate(-171.398 -213.145)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13479",
    "data-name": "Path 13479",
    d: "M231.223,297.62H192.216v-1.5h8.81a2.524,2.524,0,0,0,2.475-2.09l3.939-23.463.772-4.618h13.362l11.951,28.2A2.5,2.5,0,0,1,231.223,297.62Z",
    transform: "translate(-171.398 -213.145)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13480",
    "data-name": "Path 13480",
    d: "M227.941,294.369h-30.25a2.524,2.524,0,0,0,2.475-2.09l3.939-23.463h14l10.648,24.314A.889.889,0,0,1,227.941,294.369Z",
    transform: "translate(-168.062 -211.397)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68317",
    "data-name": "Group 68317"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13481",
    "data-name": "Path 13481",
    d: "M259.472,294.58H181.448a1.136,1.136,0,0,1-1.144-1.411l11.084-58.625a1.787,1.787,0,0,1,1.678-1.411H271.09a1.136,1.136,0,0,1,1.144,1.411L261.15,293.169A1.787,1.787,0,0,1,259.472,294.58Z",
    transform: "translate(-178.669 -233.133)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13482",
    "data-name": "Path 13482",
    d: "M259.472,294.58H181.448a1.136,1.136,0,0,1-1.144-1.411l11.084-58.625a1.787,1.787,0,0,1,1.678-1.411H271.09a1.136,1.136,0,0,1,1.144,1.411L261.15,293.169A1.787,1.787,0,0,1,259.472,294.58Z",
    transform: "translate(-178.669 -233.133)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13483",
    "data-name": "Path 13483",
    d: "M258.472,294.58H180.448a1.137,1.137,0,0,1-1.144-1.411l11.084-58.625a1.787,1.787,0,0,1,1.678-1.411H270.09a1.136,1.136,0,0,1,1.144,1.411L260.15,293.169A1.787,1.787,0,0,1,258.472,294.58Z",
    transform: "translate(-179.278 -233.133)",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13484",
    "data-name": "Path 13484",
    d: "M256.087,289.625H181.493l10.258-54.258h74.594Z",
    transform: "translate(-177.929 -231.772)",
    fill: "#d1e600"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68319",
    "data-name": "Group 68319",
    transform: "translate(34.576 76.57)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13485",
    "data-name": "Path 13485",
    d: "M147.048,288.62v-1.83l30.036-6.068h58.739a3.946,3.946,0,0,1,3.947,3.946h0a3.946,3.946,0,0,1-3.946,3.947Z",
    transform: "translate(-147.045 -280.714)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13486",
    "data-name": "Path 13486",
    d: "M239.765,284.675a3.942,3.942,0,0,1-1.143,2.784,3.994,3.994,0,0,1-2.8,1.159H147.046V286.8l30.043-6.083h58.734A3.942,3.942,0,0,1,239.765,284.675Z",
    transform: "translate(-147.046 -280.717)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13487",
    "data-name": "Path 13487",
    d: "M219.663,284.675a3.942,3.942,0,0,1-1.143,2.784,3.994,3.994,0,0,1-2.8,1.159H180.046V286.8l30.043-6.083h5.632A3.942,3.942,0,0,1,219.663,284.675Z",
    transform: "translate(-126.944 -280.717)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68326",
    "data-name": "Group 68326",
    transform: "translate(0 84.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68320",
    "data-name": "Group 68320",
    transform: "translate(148.764 9.395)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13488",
    "data-name": "Path 13488",
    d: "M218.011,492.527h8.037l14.441-201.05H229.826Z",
    transform: "translate(-218.006 -291.477)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13489",
    "data-name": "Path 13489",
    d: "M218.008,492.4h8.042L239.786,301.34l.708-9.662H229.828l-.577,9.662Z",
    transform: "translate(-218.008 -291.354)",
    fill: "#fff",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13490",
    "data-name": "Path 13490",
    d: "M224.995,300.861H235.53l.708-9.183H225.572Z",
    transform: "translate(-213.752 -291.354)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68321",
    "data-name": "Group 68321",
    transform: "translate(88.467 9.395)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13491",
    "data-name": "Path 13491",
    d: "M181.853,492.527h8.037l1.313-201.05H180.54Z",
    transform: "translate(-180.535 -291.477)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13492",
    "data-name": "Path 13492",
    d: "M180.537,291.678l.21,32.438,1.1,168.289h8.042l1.1-168.289.21-32.438Z",
    transform: "translate(-180.537 -291.354)",
    fill: "#fff",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13493",
    "data-name": "Path 13493",
    d: "M180.537,291.678l.21,32.8h10.246l.21-32.8Z",
    transform: "translate(-180.537 -291.354)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68322",
    "data-name": "Group 68322",
    transform: "translate(4.451 9.395)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13494",
    "data-name": "Path 13494",
    d: "M128.328,492.527h8.037l14.441-201.05H140.143Z",
    transform: "translate(-128.323 -291.477)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13495",
    "data-name": "Path 13495",
    d: "M128.325,492.4h8.042L150.1,301.34l.709-9.662H140.145l-.577,9.662Z",
    transform: "translate(-128.325 -291.354)",
    fill: "#fff",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13496",
    "data-name": "Path 13496",
    d: "M135.312,300.861h10.535l.709-9.183H135.889Z",
    transform: "translate(-124.069 -291.354)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68323",
    "data-name": "Group 68323",
    transform: "translate(226.272 9.395)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13497",
    "data-name": "Path 13497",
    d: "M280.615,492.527h8.037l-11.815-201.05H266.175Z",
    transform: "translate(-266.175 -291.477)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13498",
    "data-name": "Path 13498",
    d: "M266.176,291.678l.708,9.662L280.62,492.4h8.029L277.419,301.34l-.577-9.662Z",
    transform: "translate(-266.174 -291.354)",
    fill: "#fff",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13499",
    "data-name": "Path 13499",
    d: "M276.842,291.678H266.176l.708,9.183h10.535Z",
    transform: "translate(-266.174 -291.354)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68324",
    "data-name": "Group 68324",
    transform: "translate(7.819 4.36)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17404",
    "data-name": "Rectangle 17404",
    d: "M2.162,0H235.4a2.162,2.162,0,0,1,2.162,2.162V10.07a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.162A2.162,2.162,0,0,1,2.162,0Z",
    transform: "translate(237.567 10.07) rotate(180)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17405",
    "data-name": "Rectangle 17405",
    d: "M2.162,0H235.4a2.162,2.162,0,0,1,2.162,2.162V10.07a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.162A2.162,2.162,0,0,1,2.162,0Z",
    transform: "translate(237.567 10.07) rotate(180)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17406",
    "data-name": "Rectangle 17406",
    width: 237.567,
    height: 5.035,
    transform: "translate(245.386 9.395) rotate(180)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68325",
    "data-name": "Group 68325"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13500",
    "data-name": "Path 13500",
    d: "M128.4,291.312H375.927a2.837,2.837,0,0,0,2.837-2.837h0a2.836,2.836,0,0,0-2.837-2.837H128.4a2.837,2.837,0,0,0-2.837,2.837h0A2.838,2.838,0,0,0,128.4,291.312Z",
    transform: "translate(-125.559 -285.638)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13501",
    "data-name": "Path 13501",
    d: "M128.4,291.312H375.927a2.837,2.837,0,0,0,2.837-2.837h0a2.836,2.836,0,0,0-2.837-2.837H128.4a2.837,2.837,0,0,0-2.837,2.837h0A2.838,2.838,0,0,0,128.4,291.312Z",
    transform: "translate(-125.559 -285.638)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68334",
    "data-name": "Group 68334",
    transform: "translate(102.011 35.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68328",
    "data-name": "Group 68328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13502",
    "data-name": "Path 13502",
    d: "M191.352,258.223A2.4,2.4,0,0,1,189,255.363l1-5.138a3.077,3.077,0,0,1,3.012-2.481H234.86a2.4,2.4,0,0,1,2.354,2.859l-1,5.138a3.074,3.074,0,0,1-3.011,2.481Z",
    transform: "translate(-188.953 -247.744)",
    fill: "#2d5794",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13503",
    "data-name": "Path 13503",
    d: "M232.9,257.111H191.048a1.592,1.592,0,0,1-1.564-1.9l1-5.14a2.263,2.263,0,0,1,2.222-1.83h41.848a1.593,1.593,0,0,1,1.564,1.9l-1,5.14A2.263,2.263,0,0,1,232.9,257.111Z",
    transform: "translate(-188.649 -247.439)",
    fill: "#fff"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68327",
    "data-name": "Group 68327",
    transform: "translate(4.625 1.933)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_399",
    "data-name": "Ellipse 399",
    cx: 2.592,
    cy: 2.064,
    rx: 2.592,
    ry: 2.064,
    transform: "translate(0 4.247) rotate(-55.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13504",
    "data-name": "Path 13504",
    d: "M200.919,251.92a2.968,2.968,0,0,1-2.676,2.431,1.863,1.863,0,0,1-1.725-2.431,2.968,2.968,0,0,1,2.674-2.431A1.865,1.865,0,0,1,200.919,251.92Z",
    transform: "translate(-189.001 -248.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13505",
    "data-name": "Path 13505",
    d: "M204.983,251.92a2.968,2.968,0,0,1-2.674,2.431,1.864,1.864,0,0,1-1.727-2.431,2.968,2.968,0,0,1,2.676-2.431A1.863,1.863,0,0,1,204.983,251.92Z",
    transform: "translate(-186.525 -248.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_400",
    "data-name": "Ellipse 400",
    cx: 2.592,
    cy: 2.064,
    rx: 2.592,
    ry: 2.064,
    transform: "translate(19.621 4.247) rotate(-55.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13506",
    "data-name": "Path 13506",
    d: "M213.112,251.92a2.968,2.968,0,0,1-2.674,2.431,1.864,1.864,0,0,1-1.727-2.431,2.968,2.968,0,0,1,2.676-2.431A1.863,1.863,0,0,1,213.112,251.92Z",
    transform: "translate(-181.574 -248.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 2.592,
    cy: 2.064,
    rx: 2.592,
    ry: 2.064,
    transform: "translate(32.702 4.247) rotate(-55.032)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68333",
    "data-name": "Group 68333",
    transform: "translate(48.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68329",
    "data-name": "Group 68329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13507",
    "data-name": "Path 13507",
    d: "M220.776,258.223a1.829,1.829,0,0,1-1.426-.652,1.862,1.862,0,0,1-.364-1.559l1.266-6.371a2.407,2.407,0,0,1,2.287-1.9h6.371a1.823,1.823,0,0,1,1.424.652,1.862,1.862,0,0,1,.364,1.559l-1.266,6.371a2.407,2.407,0,0,1-2.287,1.9Z",
    transform: "translate(-218.946 -247.744)",
    fill: "#2d5794",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13508",
    "data-name": "Path 13508",
    d: "M220.471,257.111h6.369a1.6,1.6,0,0,0,1.5-1.249l1.266-6.369a.993.993,0,0,0-1-1.249h-6.371a1.6,1.6,0,0,0-1.5,1.249l-1.266,6.369A.994.994,0,0,0,220.471,257.111Z",
    transform: "translate(-218.642 -247.439)",
    fill: "#2d5794"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68332",
    "data-name": "Group 68332",
    transform: "translate(3.31 2.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68330",
    "data-name": "Group 68330",
    transform: "translate(1.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13509",
    "data-name": "Path 13509",
    d: "M222.239,254.882a.33.33,0,0,1-.261-.117.421.421,0,0,1,.113-.57l2.552-2.129-1.7-2.129a.42.42,0,0,1,.113-.57.4.4,0,0,1,.568,0l1.934,2.414a.422.422,0,0,1-.114.57l-2.893,2.414A.49.49,0,0,1,222.239,254.882Z",
    transform: "translate(-221.909 -249.249)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68331",
    "data-name": "Group 68331",
    transform: "translate(0 2.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13510",
    "data-name": "Path 13510",
    d: "M225.684,251.555h-4.35a.322.322,0,0,1-.323-.4.517.517,0,0,1,.483-.4h4.35a.321.321,0,0,1,.323.4A.517.517,0,0,1,225.684,251.555Z",
    transform: "translate(-221.003 -250.75)",
    fill: "#fff"
  })))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_369579",
    "data-name": "Path 369579",
    d: "M0,.089V1.455H1.353V4.789H3.17V1.455H4.526V.089H0ZM43.2.071h.86v4H46V4.79H43.2V.071Zm-3.51,3.383h.748V2.8H39.83l.364-1.162c.084-.282.154-.609.225-.886h.015l0,.018v-.7h-.532L38.393,4.792h.889l.408-1.338ZM40.437.071h.569l1.532,4.721h-.921l-.429-1.338h-.751V2.8h.6l-.373-1.162c-.089-.282-.163-.6-.231-.868v-.7ZM36.482.794H35.136V.071H38.7V.794h-1.36v4h-.859Zm-1.891,4h-.863V.074h.863ZM29.813.134V4.79h.853V3.007a2.1,2.1,0,0,0,.422.034,2.941,2.941,0,0,0,.307-.015V2.342a1.657,1.657,0,0,1-.307.028,1.481,1.481,0,0,1-.422-.043V.743a2.311,2.311,0,0,1,.5-.043,1.663,1.663,0,0,1,.231.015V.044c-.084-.006-.173-.009-.264-.009a7.392,7.392,0,0,0-1.317.1Zm1.582-.09a1.9,1.9,0,0,1,1.124.378,1.33,1.33,0,0,1,.461,1.042,1.433,1.433,0,0,1-.4,1.063,1.916,1.916,0,0,1-1.184.5V2.342a.813.813,0,0,0,.729-.841.754.754,0,0,0-.729-.785V.044ZM26.3,3.454h.744V2.8h-.606l.367-1.162c.083-.282.154-.609.222-.886h.015l0,.012v-.7H26.52L25.008,4.792h.89L26.3,3.454ZM27.048.071h.572l1.535,4.721h-.926L27.8,3.454h-.754V2.8h.606l-.371-1.162c-.088-.285-.164-.6-.235-.874v-.7ZM24.573,4.654a3.152,3.152,0,0,1-1.224.209A2.228,2.228,0,0,1,20.936,2.49,2.377,2.377,0,0,1,23.466,0a2.735,2.735,0,0,1,1.143.2l-.182.687A2.33,2.33,0,0,0,23.5.708a1.574,1.574,0,0,0-1.653,1.74A1.541,1.541,0,0,0,23.5,4.141a2.667,2.667,0,0,0,.939-.168l.139.681ZM16.756.089l1.827,4.7H16.718l-.931-2.744-.93,2.744H12.987l1.829-4.7Zm-7.69,0V1.455h1.353V4.789h1.817V1.455h1.355V.089H9.067Zm-1.38,0,1.831,4.7H7.652L6.719,2.045,5.79,4.789H3.921L5.753.089Z",
    transform: "translate(110.238 24.239)",
    fill: "#2d5794",
    fillRule: "evenodd"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_bubble",
    "data-name": "Speech bubble",
    transform: "translate(212.644 95.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68336",
    "data-name": "Group 68336"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17407",
    "data-name": "Rectangle 17407",
    width: 47.956,
    height: 47.956,
    rx: 4.123,
    transform: "translate(47.956 47.956) rotate(180)",
    fill: "#2d5794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13511",
    "data-name": "Path 13511",
    d: "M144.717,189.081l3.75,16.127,3.749-16.127Z",
    transform: "translate(-124.489 -142.915)",
    fill: "#2d5794"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68335",
    "data-name": "Group 68335",
    transform: "translate(9.693 8.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13512",
    "data-name": "Path 13512",
    d: "M152.036,195.588a28.441,28.441,0,0,1-13.864-23.4l.016-.515,14.268-6.078,14.268,6.078.016.515a28.45,28.45,0,0,1-13.864,23.4l-.42.256Z",
    transform: "translate(-138.17 -165.592)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13513",
    "data-name": "Path 13513",
    d: "M147.048,166.136l13.48,5.74a27.377,27.377,0,0,1-13.48,22.694Z",
    transform: "translate(-132.763 -165.261)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13514",
    "data-name": "Path 13514",
    d: "M152.151,166.136l-13.48,5.74a27.377,27.377,0,0,0,13.48,22.694Z",
    transform: "translate(-137.866 -165.261)",
    fill: "#fff",
    opacity: 0.4
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(82.325 174.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(64.461 0)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13515",
    "data-name": "Path 13515",
    d: "M139,279.182l11.246,1.685a42.771,42.771,0,0,1,7.851-1.685,52.323,52.323,0,0,1,8.7,0s5.091,1.908,5.091,6.789c0,0-11.882,3.183-16.444,1.274L139,285.971Z",
    transform: "translate(-62.116 -166.607)",
    fill: "#e4897b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13516",
    "data-name": "Path 13516",
    d: "M139,279.182l11.246,1.685a42.771,42.771,0,0,1,7.851-1.685,52.323,52.323,0,0,1,8.7,0s5.091,1.908,5.091,6.789c0,0-11.882,3.183-16.444,1.274L139,285.971Z",
    transform: "translate(-62.116 -166.607)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68338",
    "data-name": "Group 68338",
    transform: "translate(57.471)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68337",
    "data-name": "Group 68337",
    transform: "translate(44.736 28.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13517",
    "data-name": "Path 13517",
    d: "M157.322,231.836a29.063,29.063,0,0,0,1.348,6.818,3.77,3.77,0,0,1-3.934-.043Z",
    transform: "translate(-154.736 -223.372)",
    fill: "#aa473d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13518",
    "data-name": "Path 13518",
    d: "M159.886,230.721c-.433,1.041-1.2,1.711-1.725,1.495s-.592-1.234-.161-2.275,1.2-1.71,1.723-1.495S160.318,229.679,159.886,230.721Z",
    transform: "translate(-152.919 -225.462)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13519",
    "data-name": "Path 13519",
    d: "M163.092,227.645s-3.323-2.016-6.281-.51",
    transform: "translate(-153.471 -226.576)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.725
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13520",
    "data-name": "Path 13520",
    d: "M164.877,251.763a16.5,16.5,0,0,1-1.13,1.286,16.269,16.269,0,0,1-10.8,4.9,14.58,14.58,0,0,1-11.647-4.658,14.743,14.743,0,0,1-2.995-4.987c-2.868-7.721.056-13.813,4.176-24.5a15.687,15.687,0,0,1,26.17-5.338C176.993,227.259,171.38,243.4,164.877,251.763Z",
    transform: "translate(-120.705 -206.501)",
    fill: "#e4897b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13521",
    "data-name": "Path 13521",
    d: "M153.825,243.593a16.064,16.064,0,0,1-2.441.317,14.58,14.58,0,0,1-11.647-4.659,17.054,17.054,0,0,1,3.463-2.7S149.862,238.413,153.825,243.593Z",
    transform: "translate(-119.137 -192.457)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13522",
    "data-name": "Path 13522",
    d: "M126.935,251.424c1.054,7.54,17.528,10.353,17.528,10.353s8.131,3.7,8.464.476c-3.365-3.894-3.736-7.286-2.576-10.265a14.739,14.739,0,0,1,3.313-4.784,30.786,30.786,0,0,1,2.4-2.214l-5.025-20.634C147.418,232.2,135.045,250.308,126.935,251.424Z",
    transform: "translate(-126.935 -199.888)",
    fill: "#e4897b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13523",
    "data-name": "Path 13523",
    d: "M170.148,215.28s3.519-.438,6.216,6.124c2.275,5.531-3.077,6.726-2.847,12.608s-5.136,9.14-5.136,9.14-4.517,3.893-8.356,1.781c0,0-5.024,2.464-6.346,6.763s-9.093-3.468-16.1-2.29c0,0-4.736-4.428-4.385-15.178a37.278,37.278,0,0,1,3.373-13.48s2.044-6.4,10.049-9.978S168.64,209.914,170.148,215.28Z",
    transform: "translate(-123.132 -209.151)",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13524",
    "data-name": "Path 13524",
    d: "M149.315,231.544a7.411,7.411,0,0,0,1.374,6.2c1.717,1.862,4.462-.5,5.572-3.772.965-2.908,1.3-7.468-1.21-7.98S149.843,228.406,149.315,231.544Z",
    transform: "translate(-113.386 -198.929)",
    fill: "#e4897b"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68339",
    "data-name": "Group 68339",
    transform: "translate(10.846 50.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13525",
    "data-name": "Path 13525",
    d: "M182.279,247.743q-3.452,9.607-6.179,18.505c-1.159,3.669-2.221,7.257-3.2,10.717q-1.231,4.369-2.285,8.464c-.338,1.319-.676,2.623-1,3.91-1.77,7.1-3.2,13.565-4.329,19.262a255.276,255.276,0,0,0-4.168,27.146l-63.159-7.9c2.188-10.846,3.894-20.324,6.276-30.542,1.32-5.6,2.816-11.425,4.747-17.813,1.352-4.586,2.929-9.462,4.8-14.756,6.34-18.183,12.181-23.22,12.181-23.22C150.257,237.621,182.279,247.743,182.279,247.743Z",
    transform: "translate(-97.96 -240.624)",
    fill: "#263238"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13526",
    "data-name": "Path 13526",
    d: "M163.411,279.91l11.246,1.685a42.967,42.967,0,0,1,7.853-1.685,52.313,52.313,0,0,1,8.7,0s5.093,1.91,5.093,6.791c0,0-11.884,3.183-16.446,1.273L163.411,286.7Z",
    transform: "translate(-47.244 -166.163)",
    fill: "#e4897b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68340",
    "data-name": "Group 68340",
    transform: "translate(46.449 294.656)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13527",
    "data-name": "Path 13527",
    d: "M120.085,419.374l11.761.212,5.858-27.125-11.747-.2Z",
    transform: "translate(-120.085 -392.264)",
    fill: "#ebb376"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13528",
    "data-name": "Path 13528",
    d: "M124.963,392.264l11.746.212-3.352,15.5-11.642-.78Z",
    transform: "translate(-119.091 -392.264)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13529",
    "data-name": "Path 13529",
    d: "M163.708,403.532a369.03,369.03,0,0,1-17.131,50.59l-21.463-1.638s8.807-34.4,12-65.893c1.976-19.443,1.8-35.535-3.891-36.779-3.585-.79-11.967-.761-22.705-.512V309.273c30.138,6.189,60.128,17.863,62.411,27.227C176.113,349.68,170.54,377.58,163.708,403.532Z",
    transform: "translate(-79.467 -148.162)",
    fill: "#407bff"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68341",
    "data-name": "Group 68341",
    transform: "translate(43.37 294.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13530",
    "data-name": "Path 13530",
    d: "M118.172,402.931l25.554,1.7,3.76-11.045-28.153-1.317Z",
    transform: "translate(-118.172 -392.266)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13531",
    "data-name": "Path 13531",
    d: "M118.172,402.931l25.554,1.7,3.76-11.045-28.153-1.317Z",
    transform: "translate(-118.172 -392.266)",
    fill: "#fff",
    opacity: 0.2
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68342",
    "data-name": "Group 68342",
    transform: "translate(59.975 316.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13532",
    "data-name": "Path 13532",
    d: "M128.491,410.749c0,.013.243.018.246.031.014.043.262.08.3.111s.021.063.05.082a.164.164,0,0,0,.1-.008,14.373,14.373,0,0,0,3.062.605,3.135,3.135,0,0,0,2.237-.439,1.463,1.463,0,0,0,.426-1.5,1.042,1.042,0,0,0-.591-.816c-.753-.346-2.108.087-3.257.6a4.186,4.186,0,0,0,1.159-2.686,1.118,1.118,0,0,0-1-.89,1.726,1.726,0,0,0-1.307.307c-1.225,1.057-1.422,4.38-1.422,4.584v.024Zm1.263-.681-.241.135c.045-1.114.254-2.971.991-3.595a.791.791,0,0,1,.6-.212l.134.018c.388.071.478.269.492.428C131.8,407.637,130.752,409.207,129.754,410.068Zm.169.583c1.416-.78,3.427-1.641,4.177-1.294a.5.5,0,0,1,.283.4,1.008,1.008,0,0,1-.256.961C133.539,411.225,131.994,411.195,129.923,410.651Z",
    transform: "translate(-128.491 -405.809)",
    fill: "#407bff"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13533",
    "data-name": "Path 13533",
    d: "M134.139,408.3l-13.168-.821a.832.832,0,0,0-.917.74l0,.013-1.292,10.387a2.077,2.077,0,0,0,1.92,2.2c4.6.212,6.805.084,12.6.4,3.556.212,10.566.969,15.474.494s4.306-5.313,2.187-5.545c-5.025-.571-11.682-4.264-14.827-7.067A3.3,3.3,0,0,0,134.139,408.3Z",
    transform: "translate(-74.446 -88.343)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13534",
    "data-name": "Path 13534",
    d: "M163.708,403.532c-8.017-5.077-17.395-11.045-26.6-16.941,1.976-19.443,1.8-35.535-3.891-36.779-3.585-.79-11.967-.761-22.705-.512V309.273c30.138,6.189,60.128,17.863,62.411,27.227C176.113,349.68,170.54,377.58,163.708,403.532Z",
    transform: "translate(-79.467 -148.162)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68343",
    "data-name": "Group 68343",
    transform: "translate(115.208 294.656)"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13535",
    "data-name": "Path 13535",
    d: "M162.815,419.374l11.761.212,5.858-27.125-11.747-.2Z",
    transform: "translate(-162.815 -392.264)",
    fill: "#ebb376"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13536",
    "data-name": "Path 13536",
    d: "M167.694,392.264l11.746.212-3.352,15.5-11.642-.78Z",
    transform: "translate(-161.822 -392.264)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13537",
    "data-name": "Path 13537",
    d: "M163.719,316.41l1.892-15.2L104.185,291.1S84.1,330.9,93.93,350.409c9.019,17.9,105.024,7.235,119.8,10.466,14.93,3.263-8.1,102.672-8.1,102.672l21.461,1.638s33.161-89.469,26.343-117.611C250.457,335.295,199.849,319.037,163.719,316.41Z",
    transform: "translate(-91.22 -159.231)",
    fill: "#407bff"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68344",
    "data-name": "Group 68344",
    transform: "translate(112.13 294.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13538",
    "data-name": "Path 13538",
    d: "M160.9,402.931l25.554,1.7,3.76-11.045-28.153-1.317Z",
    transform: "translate(-160.902 -392.266)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13539",
    "data-name": "Path 13539",
    d: "M160.9,402.931l25.554,1.7,3.76-11.045-28.153-1.317Z",
    transform: "translate(-160.902 -392.266)",
    fill: "#fff",
    opacity: 0.2
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68345",
    "data-name": "Group 68345",
    transform: "translate(128.734 316.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13540",
    "data-name": "Path 13540",
    d: "M171.221,410.749c0,.013.245.018.248.031.013.043.261.08.294.111s.023.063.05.082a.164.164,0,0,0,.1-.008,14.393,14.393,0,0,0,3.062.605,3.133,3.133,0,0,0,2.237-.439,1.456,1.456,0,0,0,.426-1.5,1.044,1.044,0,0,0-.589-.816c-.755-.346-2.11.087-3.257.6a4.192,4.192,0,0,0,1.157-2.686,1.116,1.116,0,0,0-1-.89,1.73,1.73,0,0,0-1.307.307c-1.225,1.057-1.422,4.38-1.422,4.584v.024Zm1.263-.681-.241.135c.045-1.114.254-2.971.993-3.595a.791.791,0,0,1,.6-.212l.134.018c.388.071.478.269.491.428C174.526,407.637,173.482,409.207,172.484,410.068Zm.169.583c1.418-.78,3.429-1.641,4.177-1.294a.5.5,0,0,1,.283.4,1,1,0,0,1-.256.961C176.27,411.225,174.726,411.195,172.653,410.651Z",
    transform: "translate(-171.221 -405.809)",
    fill: "#407bff"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13541",
    "data-name": "Path 13541",
    d: "M176.869,408.3l-13.166-.821a.834.834,0,0,0-.919.74l0,.013-1.292,10.387a2.077,2.077,0,0,0,1.92,2.2c4.6.212,6.805.084,12.6.4,3.556.212,10.564.969,15.472.494s4.306-5.313,2.187-5.545c-5.025-.571-11.681-4.264-14.827-7.067A3.3,3.3,0,0,0,176.869,408.3Z",
    transform: "translate(-48.417 -88.343)",
    fill: "#263238"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68346",
    "data-name": "Group 68346",
    transform: "translate(10.712 134.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13542",
    "data-name": "Path 13542",
    d: "M97.877,297.145l28.462,3.732.92-4.2-28.511-4.148Z",
    transform: "translate(-97.877 -292.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13543",
    "data-name": "Path 13543",
    d: "M117.738,295.126l-.345,4.172,26.3,3.617v-4.122Z",
    transform: "translate(-85.988 -290.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13544",
    "data-name": "Path 13544",
    d: "M134.754,297.546v3.894l3.817.51v-3.765Z",
    transform: "translate(-75.413 -289.48)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13545",
    "data-name": "Path 13545",
    d: "M148.823,258.241c-1.159,3.669-2.221,7.257-3.2,10.717q-1.231,4.369-2.285,8.464c-1.979-10.781,1.609-23.655,1.609-23.655Z",
    transform: "translate(-59.836 -181.973)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13546",
    "data-name": "Path 13546",
    d: "M153.6,245.043c5.138,1.04,6.834,40.932,7.046,45.177s25.206,12.5,25.206,12.5v5.817s-26.783-1.875-33.033-4.432-7.78-39.561-7.78-39.561Z",
    transform: "translate(-58.437 -187.288)",
    fill: "#e4897b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13547",
    "data-name": "Path 13547",
    d: "M154.675,245.043c4.713,1.464,7.046,27.775,7.046,27.775l-14.574,5.873L143.53,264.06s-1.035-2.97,1-9.251C147.479,245.738,154.675,245.043,154.675,245.043Z",
    transform: "translate(-59.515 -187.288)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68352",
    "data-name": "Group 68352",
    transform: "translate(0 35.242)"
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17408",
    "data-name": "Rectangle 17408",
    d: "M7.912,0H133.806a7.912,7.912,0,0,1,7.912,7.912V19.54a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.912A7.912,7.912,0,0,1,7.912,0Z",
    transform: "translate(38.148 153.623)",
    fill: "#407bff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13548",
    "data-name": "Path 13548",
    d: "M106.275,296.455H184.3a6.238,6.238,0,0,1,6.078,7.645l-13.948,60.277h-3.223l11.885-52.827A6.239,6.239,0,0,0,179,303.942H107.866Z",
    transform: "translate(-17.588 -191.212)",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13549",
    "data-name": "Path 13549",
    d: "M131.595,339.975V390.9a2.963,2.963,0,0,1-2.961,2.961H116.147a2.953,2.953,0,0,1-2.961-2.961v-50.93Z",
    transform: "translate(-13.378 -164.702)",
    fill: "#263238"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68349",
    "data-name": "Group 68349",
    transform: "translate(38.467 287.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68347",
    "data-name": "Group 68347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13550",
    "data-name": "Path 13550",
    d: "M85.889,415.1a5.412,5.412,0,1,0-5.412,5.41A5.412,5.412,0,0,0,85.889,415.1Z",
    transform: "translate(-75.066 -409.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13551",
    "data-name": "Path 13551",
    d: "M82.158,414.081a2.7,2.7,0,1,0-2.7,2.7A2.705,2.705,0,0,0,82.158,414.081Z",
    transform: "translate(-74.041 -408.669)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68348",
    "data-name": "Group 68348",
    transform: "translate(130.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13552",
    "data-name": "Path 13552",
    d: "M166.836,415.1a5.411,5.411,0,1,0-5.41,5.41A5.411,5.411,0,0,0,166.836,415.1Z",
    transform: "translate(-156.014 -409.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13553",
    "data-name": "Path 13553",
    d: "M163.107,414.081a2.706,2.706,0,1,0-2.7,2.7A2.706,2.706,0,0,0,163.107,414.081Z",
    transform: "translate(-154.99 -408.669)",
    fill: "#fff",
    opacity: 0.2
  })))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13554",
    "data-name": "Path 13554",
    d: "M148.195,420.338V362.125h-8.953v58.213c-34.862.893-56.047,13.081-60.285,15.752a1.7,1.7,0,0,0-.79,1.442v4.837a1.711,1.711,0,0,0,1.711,1.712h0a1.711,1.711,0,0,0,1.487-.864l2.068-3.627a196.052,196.052,0,0,1,55.81-9.241v9.568a2.214,2.214,0,0,0,2.214,2.214h4.525a2.214,2.214,0,0,0,2.214-2.214v-9.568A196.048,196.048,0,0,1,204,439.589l2.068,3.627a1.713,1.713,0,0,0,1.487.864h0a1.711,1.711,0,0,0,1.712-1.712v-4.837a1.7,1.7,0,0,0-.79-1.442C204.24,433.418,183.057,421.231,148.195,420.338Z",
    transform: "translate(-34.71 -151.209)",
    fill: "#263238"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17409",
    "data-name": "Rectangle 17409",
    width: 5.874,
    height: 10.822,
    transform: "translate(106.07 287.46)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17410",
    "data-name": "Rectangle 17410",
    width: 18.409,
    height: 21.16,
    transform: "translate(99.808 175.273)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13555",
    "data-name": "Path 13555",
    d: "M221.924,337.891v6.083a3.111,3.111,0,0,1-3.122,3.106H75.572a3.1,3.1,0,0,1-3.106-3.106v-6.083a3.108,3.108,0,0,1,3.106-3.106H218.8A3.121,3.121,0,0,1,221.924,337.891Z",
    transform: "translate(-38.183 -167.863)",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13556",
    "data-name": "Path 13556",
    d: "M166.08,400.689H82.517S55.966,356.534,55.966,283.575V256.782a19.947,19.947,0,0,1,19.953-19.937h35.433a19.934,19.934,0,0,1,19.937,19.374C132.32,293.809,137.856,375.216,166.08,400.689Z",
    transform: "translate(-48.233 -227.523)",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13557",
    "data-name": "Path 13557",
    d: "M147.7,400.689h-61.4a6.343,6.343,0,0,1-5.643-3.416c-6.044-11.657-24.684-52.566-24.684-113.7V256.782A19.937,19.937,0,0,1,75.9,236.845h30.622a19.934,19.934,0,0,1,19.937,19.374c.919,33.583,5.436,102.139,26.516,134.538A6.383,6.383,0,0,1,147.7,400.689Z",
    transform: "translate(-48.233 -227.523)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13558",
    "data-name": "Path 13558",
    d: "M192.411,337.891v6.083a3.107,3.107,0,0,1-3.106,3.106H125.114a4.2,4.2,0,0,1-4.2-4.2v-3.9a4.2,4.2,0,0,1,4.2-4.2h64.175A3.121,3.121,0,0,1,192.411,337.891Z",
    transform: "translate(-8.669 -167.863)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68351",
    "data-name": "Group 68351"
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13559",
    "data-name": "Path 13559",
    d: "M72.45,238.007l5.305-6.955s22.686,1.031,23.226,9.322S72.45,238.007,72.45,238.007Z",
    transform: "translate(-38.192 -231.052)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68350",
    "data-name": "Group 68350",
    transform: "translate(5.242 27.756)"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13560",
    "data-name": "Path 13560",
    d: "M68.533,248.3s1.384,36.84,0,131.96c-.048,3.207-12.007,3.1-12.833,0-2.884-10.822,0-97.305,0-97.305",
    transform: "translate(-54.419 -248.301)",
    fill: "#407bff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13561",
    "data-name": "Path 13561",
    d: "M55.361,330.6l12.214.415v6.1l-12.214-.627Z",
    transform: "translate(-53.844 -198.166)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13562",
    "data-name": "Path 13562",
    d: "M68.533,248.3s1.384,36.84,0,131.96c-.048,3.207-12.007,3.1-12.833,0-2.884-10.822,0-97.305,0-97.305",
    transform: "translate(-54.419 -248.301)",
    fill: "#fff",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13563",
    "data-name": "Path 13563",
    d: "M51.887,370.039c-.657-17.532-3.061-98.142,7.006-124.86,0,0,9.481-12.038,41.558-12.038s41.725,22.765,41.725,22.765,1.384,36.84,0,131.958c-.047,3.209-12.006,3.1-12.833,0-2.884-10.822,0-97.3,0-97.3l-6.419,78.676a1.932,1.932,0,0,1-2.217,1.752c-10.117-1.559-54.751-7.867-66.5.18A1.464,1.464,0,0,1,51.887,370.039Z",
    transform: "translate(-51.161 -229.779)",
    fill: "#407bff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13564",
    "data-name": "Path 13564",
    d: "M99.894,329.59l12.214.416v6.1l-12.214-.627Z",
    transform: "translate(-21.475 -171.027)",
    fill: "#407bff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13565",
    "data-name": "Path 13565",
    d: "M120.422,320.794l-.965,6.424s-49.769-10.859-65.9.7l-.956-7.129S65.057,309.315,120.422,320.794Z",
    transform: "translate(-50.281 -179.493)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13566",
    "data-name": "Path 13566",
    d: "M51.887,370.039c-.657-17.532-3.061-98.142,7.006-124.86,0,0,9.481-12.038,41.558-12.038s41.725,22.765,41.725,22.765,1.384,36.84,0,131.958c-.047,3.209-12.006,3.1-12.833,0-2.884-10.822,0-97.3,0-97.3l-6.419,78.676a1.932,1.932,0,0,1-2.217,1.752c-10.117-1.559-54.751-7.867-66.5.18A1.464,1.464,0,0,1,51.887,370.039Z",
    transform: "translate(-51.161 -229.779)",
    fill: "#d1e600",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13567",
    "data-name": "Path 13567",
    d: "M99.839,281.943s.708-24.979,12.833-34.655C112.672,247.288,97.506,253.813,99.839,281.943Z",
    transform: "translate(-21.657 -221.162)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13568",
    "data-name": "Path 13568",
    d: "M83.793,234.929s-14.642,7.978-16.977,117.684C66.816,352.613,60.45,242.017,83.793,234.929Z",
    transform: "translate(-42.107 -228.69)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginbg);
export default __webpack_public_path__ + "static/media/loginbg.8f3d71eca014765376ddf40136f37d16.svg";
export { ForwardRef as ReactComponent };